export const ROW_HEIGHT_SMALL = 56
export const ROW_HEIGHT_MEDIUM = 90

export const SUBROW_HEIGHT_SMALL = 56
export const SUBROW_HEIGHT_MEDIUM = 70
